* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: auto;
}

.hidden {
  display: none;
}

.title {
  text-transform: uppercase;
  margin-top: calc(var(--spacer) * 3);
  margin-bottom: calc(var(--spacer) * 2);
}

.flex-group {
  display: flex;
}

gz-text {
  margin-bottom: calc(var(--spacer) * 3);
  line-height: 1.15;
  &#reboot-preferences-notice {
    line-height: 21px;
  }
}

#reboot-preferences-radio-options-form-field {
  gz-radio {
    height: 32px;
    margin-bottom: var(--spacer);
    display: flex;
    align-items: center;
    &#reboot-preferences-radio-options-third {
      margin-bottom: 0;
    }
  }
}

#reboot-between {
  align-items: center;
  margin-bottom: calc(var(--spacer) * 2.25);

  #between-end-form-field {
    max-width: 152px;
    margin-right: var(--spacer);
  }

  gz-title:not(.form-description) {
    margin-bottom: 0;
    max-width: 50px;
    text-align: center;
    margin-right: var(--spacer);
  }

  #after-description {
    display: flex;
    align-items: center;
  }

  gz-textarea {
    margin-top: calc(var(--spacer) * 1.5);
  }

  #reboot-between-labeled-content {
    .flex-group {
      display: flex;
      align-items: baseline;
      margin: 0 0 calc(var(--spacer) * 1.5) calc(var(--spacer) * 2);

      gz-title {
        margin-right: 0;
      }
    }
  }

  #reboot-between-custom-message-form-field,
  #reboot-between-minutes-form-field {
    margin-left: calc(var(--spacer) * 33.25);

    gz-dropdown {
      margin-right: var(--spacer);
    }

    .flex-group {
      align-items: baseline;
    }
  }

  #reboot-between-minutes-form-field .flex-group {
    .minutes-dropdown {
      --form-field-input-width: 100%;
    }

    gz-text,
    gz-input-error,
    gz-dropdown {
      width: auto;
    }

    .form-description {
      max-width: 45%;
      padding-right: var(--spacer);
    }
  }
}

#reboot-after {
  padding-left: calc(var(--spacer) * 33.25);

  #reboot-after-minutes-form-field {
    margin-bottom: calc(var(--spacer) * 3);
    gz-dropdown {
      max-width: 65px;
      margin-right: var(--spacer);
    }
    gz-text {
      display: flex;
      align-items: center;
      margin-bottom: 0;
    }
  }

  gz-textarea {
    margin-top: calc(var(--spacer) * 1.5);
  }
}

.reboot-preferences-notice-subsection {
  display: block;
  width: 100%;

  #reboot-preferences-notice {
    display: inline;
  }
}
